import { CONFIG } from 'app/core/config';
import { HierarchyTemplateAttribute } from 'app/viewmodels/admin/hierarchy-templates/hierarchy-template-attribute';
import { HierarchyTemplateMitigation } from 'app/viewmodels/admin/hierarchy-templates/hierarchy-template-mitigation';
import { AssetFamily } from '../../hierarchy/asset-family';
import { ViewModel } from '../../view-model';
import { HierarchyTemplateTab } from './hierarchy-template-tab';

export class HierarchyTemplate implements ViewModel {
  public readonly friendlyTypeNameSingular: string = 'Hierarchy Template';
  public readonly apiRoute: string = CONFIG.apiRoutes.hierarchyTemplates;

  public hierarchyTemplateId: string;
  public name: string;
  public description: string;
  public assetFamilyId: string;
  public assetFamily: AssetFamily;
  public isPiping: boolean;
  public attributes: HierarchyTemplateAttribute[] = [];
  public mitigations: HierarchyTemplateMitigation[] = [];
  public hierarchyTemplateTabs: HierarchyTemplateTab[] = [];

  public json(): any {
    return this;
  }

  public loadFromJson(data): void {
    this.hierarchyTemplateId = data.hierarchyTemplateId;
    this.name = data.name;
    this.description = data.description;
    this.assetFamilyId = data.assetFamilyId;
    this.isPiping = data.isPiping;

    if (data.assetFamily) {
      this.assetFamily = new AssetFamily();
      this.assetFamily.loadFromJson(data.assetFamily);
    }

    if (data.attributes) {
      data.attributes.forEach(attribute => {
        const newAttribute = new HierarchyTemplateAttribute();

        newAttribute.loadFromJson(attribute);
        this.attributes.push(newAttribute);
      });
    }

    if (data.mitigations) {
      data.mitigations.forEach(mitigation => {
        const newMitigation = new HierarchyTemplateMitigation();

        newMitigation.loadFromJson(mitigation);
        this.mitigations.push(newMitigation);
      });
    }

    if (data.hierarchyTemplateTabs) {
      data.hierarchyTemplateTabs.forEach(tab => {
        const templateTab = new HierarchyTemplateTab();

        templateTab.loadFromJson(tab);
        this.hierarchyTemplateTabs.push(templateTab);
      });
    }
  }
}
